//@ts-check
import createBatchAction from '@/common/lib/create-batch-action';
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import { errorHandler } from '../ajax';
import { openFailedDialog } from '@/common/components/kf-dialog';
import { STATUS_FAILURE_NO_TARGET, STATUS_FAILURE_TOP_REGISTERDONE, STATUS_FAILURE_TOP_EXISTSOWNER } from '@/common/constants';
import { updateResult } from '../result/result.action';

export const registerRequest = createBatchAction('@@register/REGISTER_REQUEST', () => [showLoading()]);
export const registerSuccess = createBatchAction('@@register/REGISTER_SUCCESS', () => [
  hideLoading(),
  updateResult('メールアドレスに新規登録用のメールを送信しました。')
]);
export const registerFailure = createBatchAction('@@register/REGISTER_FAILURE', (err) => [
  hideLoading(),
  err.status === STATUS_FAILURE_TOP_EXISTSOWNER ? 
    openFailedDialog('すでに存在しているアカウントです。') : 
    errorHandler(err)
]);

export const registerUrlRequest = createBatchAction('@@register/REGISTER_URL_REQUEST', () => [showLoading()]);
export const registerUrlSuccess = createBatchAction('@@register/REGISTER_URL_SUCCESS', () => [
  hideLoading(),
  updateResult('新規登録に成功しました。')
]);

const urlFailureHandler = (e) => {
  switch (e.status) {
    case STATUS_FAILURE_NO_TARGET:
      return openFailedDialog('urlの期限が切れています。');
  
    case STATUS_FAILURE_TOP_EXISTSOWNER:
      return openFailedDialog('すでに存在しているアカウントです。');
  
    case STATUS_FAILURE_TOP_REGISTERDONE:
      return openFailedDialog('URLが使用済みです。');
      
    default:
      return errorHandler(e);
  }
};

export const registerUrlFailure = createBatchAction('@@register/REGISTER_URL_FAILURE', (err) => [
  hideLoading(),
  updateResult('新規登録に失敗しました。'),
  urlFailureHandler(err)
]);
